// @flow
import React, { Component } from "react";
import withStyles from "elevate-ui/withStyles";
import classNames from "classnames";
import get from "lodash/get";

import Scaffold from "elevate-ui/Scaffold";

type $Props = {
  classes: Object,
  className: string,
  field: Object,
  form: Object,
  id: string,
  label: string,
  theme: Object,
  type: string,
  tabIndex: string,
  withScaffold: boolean,
  handleChange: Object,
};

type $State = {
  value: string,
};

const normalizeInput = (value) => {
  if (!value) return value;
  let currentValue = value.replace(/[^\d]/g, "");
  const cvLength = currentValue.length;

  // If the input is coming out of the props formatted with the "1" country code
  if (currentValue.match(/1[\d]{10}/)) {
    currentValue = currentValue.slice(1, 11);
  }

  if (cvLength < 4) {
    return currentValue;
  }
  if (cvLength < 7) {
    return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`;
  }

  return `(${currentValue.slice(0, 3)}) ${currentValue.slice(
    3,
    6
  )}-${currentValue.slice(6, 10)}`;
};

class Input extends Component<$Props, $State> {
  render() {
    const {
      classes,
      className,
      field,
      form: { touched, errors, setFieldValue },
      id,
      label,
      tabIndex = "0",
      type = "tel",
    } = this.props;

    if (field.value.length > 0) {
      const origValue = field.value;
      field.value = normalizeInput(field.value);
      // Make sure to call the Formik function if the values are different
      if (origValue !== field.value) {
        setFieldValue(field.name, field.value);
      }
    }

    if (type !== "hidden") {
      return (
        <Scaffold
          id={id}
          label={label}
          error={get(touched, field.name) && get(errors, field.name)}
        >
          <input
            type={type}
            id={id}
            pattern="([0-9]{3}) [0-9]{3}-[0-9]{4}"
            className={classNames(classes.root, className)}
            tabIndex={tabIndex}
            maxLength="14"
            {...field}
          />
        </Scaffold>
      );
    } else {
      return (
        <input
          type={type}
          id={id}
          pattern="([0-9]{3}) [0-9]{3}-[0-9]{4}"
          className={classNames(classes.root, className)}
          tabIndex={tabIndex}
          maxLength="14"
          {...field}
        />
      );
    }
  }
}

//

const styles = (theme) => ({
  root: {
    display: "block",
    width: "100%",
    height: "40px",
    color: theme.typography.bodyColor,
    fontFamily: "inherit",
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "20px",
    backgroundColor: "#fff",
    border: `1px solid ${theme.colors.gray300}`,
    padding: "8px 12px",
    boxShadow: "none", // Reset default inputs for mozilla
    "-webkit-appearance": "none", // Reset default browser styles
    "-moz-appearance": "none", // Reset default browser styles

    "&:focus": {
      outline: "none", // Disable default focus glow
      boxShadow: theme.globalBoxShadow, // Add back focus style
    },

    "&:disabled": {
      cursor: "not-allowed",
    },
  },
});

export default withStyles(styles, { name: "EuiInput" })(Input);
